import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import AuthLayout from "@/layout/auth/AuthLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFound.vue";

// Developer Portal
import Account from "@/pages/Account.vue";
import ReceiptHistory from "@/pages/ReceiptHistory.vue";
import Settings from "@/pages/Settings.vue";

// Auth pages
import Login from "@/pages/Auth/Login.vue";
import Signup from "@/pages/Auth/Signup.vue";
import ResetPassword from "@/pages/Auth/ResetPassword.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/settings",
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "account",
        name: "Account",
        component: Account
      },
      {
        path: "receipt-history",
        name: "Receipt History",
        component: ReceiptHistory
      },
      {
        path: "docs",
        name: "Docs",
        beforeEnter() { window.open('https://docs.quickreceipts.co', '_blank') }
      },
      {
        path: "settings",
        name: "Settings",
        component: Settings
      }
    ]
  },
  {
    path: '/',
    name: 'auth',
    component: AuthLayout,
    redirect: 'login',
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login
      },
      {
        path: 'signup',
        name: 'Signup',
        component: Signup
      },
      {
        path: 'reset-password',
        name: 'Reset Password',
        component: ResetPassword
      }
    ]
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
